<template>
  <UBadge color="success" class="shadow-sm" :style="{
    backgroundColor: `${tag.bgColor}`,
    color: `${tag.textColor}`
  }">
    {{ tag.name }}
  </UBadge>
</template>

<script setup lang="ts">
import type { ProductTag } from '~/types'

defineProps<{
  tag: ProductTag
}>()
</script>
